import {
	IFilterDefinition,
	ISelectFilterDefinition,
	ITextFilterDefinition,
	OptionType
} from '@evinced-private/ui-common';

import {
	DEFAULT_MOBILE_PLATFORM,
	MOBILE_APP_ID_FILTER_ID,
	MOBILE_PLATFORM_FILTER_ID,
	MOBILE_PLATFORM_OPTIONS
} from 'src/apps/dashboard/constants/MobileDashboard.constants';

import { DASHBOARD_DATE_RANGE_OPTIONS } from './DashboardFiltersDefinitions';

const MOBILE_DATE_RANGE_FILTER: ISelectFilterDefinition = {
	id: 'dateRange',
	label: 'Date range',
	filterType: 'select',
	defaultValue: [DASHBOARD_DATE_RANGE_OPTIONS[0]],
	componentProps: {
		placeholder: 'Last 7 days',
		isMultiple: false,
		id: 'dateRange',
		label: 'Date range',
		listboxWidth: '180px'
	}
};

const MOBILE_PLATFORM_FILTER: ISelectFilterDefinition = {
	id: MOBILE_PLATFORM_FILTER_ID,
	label: 'Platform',
	filterType: 'select',
	defaultValue: [{ value: DEFAULT_MOBILE_PLATFORM, label: 'All platforms' }],
	componentProps: {
		placeholder: 'All platforms',
		isMultiple: false,
		id: MOBILE_PLATFORM_FILTER_ID,
		label: 'Platform',
		listboxWidth: '180px'
	}
};

const MOBILE_ISSUES_SEARCH_FILTER: ITextFilterDefinition = {
	id: 'searchValue',
	label: 'Search',
	filterType: 'text',
	defaultValue: '',
	componentProps: {
		className: 'search-filter'
	}
};

const MOBILE_APP_ID_FILTER: IFilterDefinition = {
	id: MOBILE_APP_ID_FILTER_ID,
	label: 'App ID',
	filterType: 'text',
	defaultValue: [],
	componentProps: {
		placeholder: 'Filter by App ID',
		id: MOBILE_APP_ID_FILTER_ID,
		label: 'App ID'
	}
};

export const MOBILE_FILTER_DEFINITIONS: IFilterDefinition[] = [
	MOBILE_PLATFORM_FILTER,
	MOBILE_APP_ID_FILTER,
	MOBILE_DATE_RANGE_FILTER
];

export const MOBILE_ISSUES_FILTER_DEFINITIONS: IFilterDefinition[] = [
	MOBILE_ISSUES_SEARCH_FILTER,
	MOBILE_PLATFORM_FILTER,
	MOBILE_APP_ID_FILTER,
	MOBILE_DATE_RANGE_FILTER
];

export const MOBILE_FILTER_OPTIONS: Record<string, OptionType[]> = {
	dateRange: DASHBOARD_DATE_RANGE_OPTIONS,
	[MOBILE_PLATFORM_FILTER_ID]: MOBILE_PLATFORM_OPTIONS
};
